import { render } from "./index.vue?vue&type=template&id=3d3a4bc5&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3d3a4bc5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d3a4bc5"

export default script